import {InjectionToken} from '@angular/core';

export interface DataRequirements {
}

export const DataRequirementsInjectionToken = new InjectionToken<DataRequirements>('page-not-found Data Requirements')
